import classes from './Loading.module.scss';

const Loading = ({text}) => {
    return (<div className={classes.loadingContainer}>
        <div className={classes.loader}></div>
        <p>Loading {text}...</p>
    </div>);    
}

export default Loading;